/** The legacy GOT reports, by the role menu that lists them (map §7). */
import { GOT_WEB_REPORT_PERMISSIONS } from "@nexseed/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { GotReportsIndex } from "@/features/got/reports/reports-page";

export const Route = createFileRoute("/_app/quality/got/reports/")({
  beforeLoad: () => {
    // Any GOT report's own code opens the list (user, 2026-10-16).
    const { can } = useAuth.getState();
    if (!GOT_WEB_REPORT_PERMISSIONS.some((c) => can(c)))
      throw redirect({ to: "/" });
  },
  component: GotReportsIndex,
});
